(() => {
  const badgeText = document.currentScript?.dataset.hgAiBadge || '';
  const isAi = (alt) => typeof alt === 'string' && alt.startsWith('KI-Bild:');
  const attachedLightboxes = new WeakSet();

  const syncBadge = (container) => {
    const image = container?.querySelector('img');
    if (!container || !image) return;
    let badge = container.querySelector(':scope > .hg-ai-badge');
    if (!isAi(image.alt)) {
      badge?.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'hg-ai-badge';
      container.appendChild(badge);
    }
    badge.textContent = badgeText;
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const picker = event.target.closest('[is="product-bundle-picker"]');
    const option = event.target.selectedOptions[0];
    if (!picker || !option?.hasAttribute('data-img-alt')) return;
    const image = picker.querySelector('img');
    if (!image) return;
    image.alt = option.dataset.imgAlt;
    syncBadge(image.closest('[data-hg-ai-dynamic]'));
  });

  document.addEventListener('variant:change', () => {
    queueMicrotask(() => {
      document.querySelectorAll('[data-sticky-product-media][data-hg-ai-dynamic]').forEach(syncBadge);
    });
  }, true);

  document.addEventListener('bundle:added', (event) => {
    const { product, variant } = event.detail || {};
    if (!product || !variant) return;
    const fallbackAlt = product.querySelector('[data-product-image-alt]')?.dataset.productImageAlt || '';
    const alt = variant.featured_media?.alt ?? fallbackAlt;
    const bundle = event.target;
    queueMicrotask(() => {
      bundle.querySelectorAll('[data-variant-id]').forEach((item) => {
        if (String(item.dataset.variantId) !== String(variant.id)) return;
        const container = item.querySelector('[data-product-bundle-variant-media]');
        const image = container?.querySelector('img');
        if (!image) return;
        image.alt = alt;
        syncBadge(container);
      });
    });
  });

  document.addEventListener('lightbox:open', (event) => {
    const gallery = event.target.closest('media-gallery');
    const lightbox = gallery?.photoswipe;
    if (!lightbox || attachedLightboxes.has(lightbox)) return;
    attachedLightboxes.add(lightbox);

    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'hg-ai-disclosure',
        className: 'hg-ai-badge hg-ai-badge--lightbox',
        tagName: 'span',
        isButton: false,
        appendTo: 'root',
        onInit: (badge, pswp) => {
          badge.textContent = badgeText;
          badge.hidden = true;
          let frame = 0;
          const update = () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
              const slide = pswp.currSlide;
              const image = slide?.content?.element;
              const visible = isAi(slide?.data?.alt) && image instanceof HTMLImageElement;
              badge.hidden = !visible;
              if (!visible) return;
              const rootRect = pswp.element.getBoundingClientRect();
              const imageRect = image.getBoundingClientRect();
              const left = Math.max(0, imageRect.left - rootRect.left) + 8;
              const bottom = Math.min(rootRect.height, imageRect.bottom - rootRect.top) - 8;
              badge.style.left = `${left}px`;
              badge.style.top = `${Math.max(8, bottom - badge.offsetHeight)}px`;
            });
          };
          ['change', 'afterInit', 'openingAnimationEnd', 'zoomPanUpdate', 'resize', 'loadComplete'].forEach((name) => pswp.on(name, update));
          pswp.on('close', () => { badge.hidden = true; cancelAnimationFrame(frame); });
          pswp.on('destroy', () => cancelAnimationFrame(frame));
          update();
        }
      });
    });
  }, true);
})();
